

import { useQuery } from "@tanstack/react-query";
import { getBatchDetail, getByPartitionKey } from "../services/api-service";

const tableName = "JobStatus";

export interface BatchHistory {
  PartitionKey: string;
  RowKey: string;
  BatchId: string;
  InvoiceDate: string;
  CreatedBy: string;
  FileName: string;
  ExportDate: Date;
  CreatedDate: Date;
  JobStatus: string;
  FileStatus: string;
  PostToTally?: string;
  TallyResponse?:string;
 
}

const getBatchHistory = async (tenantId: string) => {
  const getBatchHistory = async (tenantId: string) => {
    return new Promise<BatchHistory[]>((resolve) => {
      setTimeout(async () => {
        const batchHistory = await getByPartitionKey(tableName, tenantId);
        resolve(batchHistory as BatchHistory[]);
      }, 1000);
    });
  };
  return await getBatchHistory(tenantId);
};

export const useGetBatchHistory = (tenantId: string) =>
  useQuery({
    queryKey: ["batchHistory", tenantId],
    queryFn: () => getBatchHistory(tenantId),
  });

export const useGetBatchDetail = (tenantId: string, batchId: string) =>
  useQuery({
    queryKey: ["batchHistory", tenantId, batchId],
    queryFn: () => getBatchDetail(tenantId, batchId),
  });
